import { AppShell } from "@mantine/core"
import { useLocation } from "react-router-dom"
import NCEHeader from "../NCEHeader/NCEHeader"
import NCENavbar from "../NCENavbar/NCENavbar"

const AUTH_ROUTES = ["/login", "/register", "/forgot-password"];

export default function AppContainer({ user, logout, children }) {
	const location = useLocation();
	const path = location.pathname;
	const isAuthRoute = AUTH_ROUTES.includes(path) || path.startsWith("/reset-password");

	return (
		<AppShell
			padding={isAuthRoute ? 0 : "md"}
			navbar={isAuthRoute ? undefined : <NCENavbar />}
			header={<NCEHeader user={user} logout={logout} />}
			styles={isAuthRoute ? { main: { padding: 0 } } : undefined}
		>
			{children}
		</AppShell>
	)
}